export const executionRunsFeatureFlags = {
  relatedTables: 'executionRuns.relatedTables',
} as const;

export const appExecutionRunsFeatureFlagKeys = [executionRunsFeatureFlags.relatedTables] as const;

export const superuserExecutionRunsFeatureFlagKeys = [
  executionRunsFeatureFlags.relatedTables,
] as const;
